import {
  DETAIL_ANIMAL_SEARCH_TYPES,
  SEARCH_TYPE,
} from '@/constants/searchType';
import { QUICK_SEARCH_MIN_LENGTH } from './quickSearchConfig';

const MIN_LENGTH_NOTE = `Enter at least ${QUICK_SEARCH_MIN_LENGTH} characters, then press Enter or choose Show results.`;

export function getHeroSearchPlaceholder(searchType: string): string {
  if (searchType === SEARCH_TYPE.SALE_CATALOGUES) {
    return 'Search sales by name';
  }
  if (searchType === SEARCH_TYPE.MEMBERS) {
    return 'Search members by name or ident';
  }
  if (
    searchType === SEARCH_TYPE.ANIMAL ||
    DETAIL_ANIMAL_SEARCH_TYPES.includes(searchType)
  ) {
    return 'Search animals by name or ident';
  }
  return 'Search by name or ident';
}

export function shouldShowQuickSearchTips(searchType: string): boolean {
  return (
    searchType !== SEARCH_TYPE.MATING &&
    searchType !== SEARCH_TYPE.DOWNLOADS &&
    searchType !== SEARCH_TYPE.ONLINE_REGISTRATIONS
  );
}

export type HeroSearchTipsContent = {
  title: string;
  intro: string;
  minLengthNote: string;
  /** When set, shown before the Wildcards section (multi-ident → Basic search). */
  multiIdentNote?: string;
  wildcardIntro: string;
  wildcardExamples: ReadonlyArray<{ pattern: string; description: string }>;
  wildcardNote: string;
};

export function getHeroSearchTipsContent(
  searchType: string,
): HeroSearchTipsContent {
  const isMembers = searchType === SEARCH_TYPE.MEMBERS;

  if (isMembers) {
    return {
      title: 'Quick search',
      intro:
        'Use the search box at the top of the page to find members. Your text is matched against member name, ident, and herd prefix.',
      minLengthNote: MIN_LENGTH_NOTE,
      multiIdentNote:
        'Paste a comma-separated list of member idents into this box to match any of them. Basic search also supports multi-ident chips.',
      wildcardIntro:
        'Add % or * to narrow partial matches. Both characters work the same way:',
      wildcardExamples: [
        { pattern: 'SM%', description: 'starts with SM' },
        { pattern: '%SM%', description: 'contains SM anywhere' },
        { pattern: '%SM', description: 'ends with SM' },
      ],
      wildcardNote:
        'Without wildcards, plain text is matched as a partial search across those fields.',
    };
  }

  return {
    title: 'Quick search',
    intro:
      'Use the search box at the top of the page to find animals. Your text is matched against animal name and ident.',
    minLengthNote:
      'Enter at least 2 characters, then press Enter or choose Show results.',
    multiIdentNote:
      'Paste a comma-separated list of animal idents into this box to match any of them. Basic search also supports multi-ident chips.',
    wildcardIntro:
      'Add % or * to narrow partial matches. Both characters work the same way:',
    wildcardExamples: [
      { pattern: 'AB%', description: 'starts with AB' },
      { pattern: '%AB%', description: 'contains AB anywhere' },
      { pattern: '%AB', description: 'ends with AB' },
    ],
    wildcardNote:
      'Without wildcards, plain text is matched as a partial search across name and ident.',
  };
}

export const IDENT_CHIP_PLACEHOLDER = 'Search by name or ident';
